<template>
  <v-flex 
    class="text-center"
    :class="{'register-form': $vuetify.breakpoint.lgAndUp}"
  >
    <v-card 
      flat 
      class="px-4 py-8" 
      style="background-color: transparent;"
    >
      <v-alert
        v-if="errors_exist"
        dismissible
        type="error"
        class="rounded-0"
      >
        {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
        <ul v-if="errors">
          <div v-for="(error, index) in errors">
            <li :key="index">{{ error[0] }}</li>
          </div>
        </ul>
      </v-alert>
      <v-card-text>
        <v-img
          alt="Vuetify Logo"
          src="@/assets/agriportal-logo.png"
          class="mx-auto"
          width="200"
        />
        <v-form
          class="mt-12"
          v-model="isValid" 
          @submit.prevent="registerSubmit"
        >
          <v-text-field 
            v-model="form.name"
            label="Tên hiển thị" 
            class="require"
            placeholder="Chúng tôi nên xưng hô với bạn như thế nào đây?"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-text-field 
            v-model="form.email"
            label="E-Mail hoặc Số điện thoại"
            outlined
            dense
          />
          <v-text-field 
            v-model="form.user_info.username"
            label="Tên tài khoản" 
            class="require"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-text-field 
            v-model="form.password" 
            label="Mật khẩu" 
            class="require"
            :type="showp1 ? 'text' : 'password'"
            :append-icon="showp1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showp1 = !showp1"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-text-field 
            v-model="form.password_confirmation" 
            label="Nhập lại mật khẩu" 
            class="require"
            :type="showp2 ? 'text' : 'password'"
            :append-icon="showp2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showp2 = !showp2"
            :rules="[v => !!v]"
            outlined
            dense
          />
          <v-btn 
            v-if="options.isLoggingIn" 
            large
            class="mb-4" 
            color="primary" 
            block="block" 
            type="submit" 
            :loading="loading"
            :disabled="!isValid"
          >Đăng ký</v-btn>
          <div class="text-body-2">
            Đã có tài khoản?
            <a href="login">
              Đăng nhập
            </a>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    name: "register",
    data() {
      return {
        isUser: true,
        isBusiness: false,
        showp1: false,
        showp2: false,
        form: {
          name: null,
          email: null,
          user_info: {
            username: null
          },
          password: null,
          password_confirmation: null,
          business:{
            loai_id: null,
            ten_co_so: null,
            dia_chi: null,
            so_dien_thoai: null,
          },
          roles: []
        },
        isValid: true,
        loading: false,
        options: {
          isLoggingIn: true,
          shouldStayLoggedIn: true,
        },
        errors_exist: false,
        errors: [],
        tab: null,
        types: [],
        typeSelected: null,
      };
    },
    mounted() {
      this.getTypes();
    },
    methods: {
      ...mapActions([
        'register'
      ]),
      getTypes () {
        axios.get("api/v1/public/business-types")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      registerSubmit () {
        const app=this;
        app.loading=true;
        app.errors_exist=false;
        app.errors=[];
        app.form.isBusiness=app.isBusiness;
        app.register(app.form)
          .then(() => {
            app.loading=false;
            app.$router.push({ name: 'Login' });
          })
          .catch(error => {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          })
      }
    }
  };
</script>
<style>
  .register-form {
    max-width: 470px;
    margin: 0 auto;
  }
</style>